<!-- 用一个更好的方式服务企业 -->
<template>
  <div class="e_world">
    <div class="styleBox_02">
      <div>
        <p>
          Own a company built on
          <span>Data Center (IDC), Cloud Native Infrastructure (LAS)</span>Supra
          <span>Fast, safe, and agile</span>The network can enable enterprises.
        </p>
        <ul class="animate__animated animate__fadeInUp">
          <li>
            <img :src="baseImgUrl + '/u/20230101/checked_1672573265281.png'" />Get rid of native infrastructure with rigid functionality
          </li>
          <li>
            <img :src="baseImgUrl + '/u/20230101/checked_1672573265281.png'" />Free from single point solutions related to access speed, security vulnerabilities, and business changes;
          </li>
          <li>
            <img :src="baseImgUrl + '/u/20230101/checked_1672573265281.png'" />Pay more attention to the business logic itself;
          </li>
          <li>
            <img :src="baseImgUrl + '/u/20230101/checked_1672573265281.png'" />Shorten the cycle of developing new products;
          </li>
          <li>
            <img :src="baseImgUrl + '/u/20230101/checked_1672573265281.png'" />Respond quickly to changes in the business environment or competitive landscape
          </li>
        </ul>
      </div>
      <img class="topBanner" :src="baseImgUrl + '/u/20230408/996 x 596_1680939753417.png'" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      baseImgUrl: ''
    }
  },
  methods: {
  },
  created () {
    this.baseImgUrl = this.$axios.defaults.baseURL
  },
  mounted () {
  },
  computed: {
  }
}
</script>
<style lang="less" scoped>
@media only screen and (min-width: 1024px) {
  .styleBox_02 {
    max-width: 1180px;
    box-shadow: 0px 2px 12px 0px rgba(204, 204, 204, 0.5);
    margin: 0 auto;
    padding: 59px 50px;
    border-radius: 24px;
    display: flex;
    justify-content: space-between;
  }

  .styleBox_02 div {
    text-align: left;
    width: 40%;
  }

  .styleBox_02 div p {
    font-size: 22px;
    font-weight: bold;
    color: #353535;
    line-height: 40px;
    margin-bottom: 12px;
  }

  .styleBox_02 div p span {
    color: #428bf8;
  }

  .styleBox_02 div ul li {
    font-size: 16px;
    font-weight: 600;
    color: #4c5461;
    line-height: 24px;
    display: flex;
    align-items: start;
    margin-bottom: 12px;
  }

  .styleBox_02 div ul li img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    margin-top: 2px;
  }

  .styleBox_02 img {
    width: 50%;
    max-width: 1180px;
    border-radius: 12px;
  }
}

@media only screen and (max-width: 1024px) {
  .styleBox_02 {
    max-width: 92%;
    box-shadow: 0px 2px 12px 0px rgba(204, 204, 204, 0.5);
    margin: 0 auto;
    padding: 1rem;
    border-radius: 0.875rem;
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;
  }

  .styleBox_02 div {
    text-align: left;
    width: 95%;
    margin: 0 auto;
  }

  .styleBox_02 .topBanner {
    margin-bottom: 1rem;
  }

  .styleBox_02 div p {
    font-size: 1rem;
    font-weight: bold;
    color: #353535;
    line-height: 1.625rem;
    margin-bottom: 1.4375rem;
  }

  .styleBox_02 div p span {
    color: #428bf8;
  }

  .styleBox_02 div ul li {
    font-size: 0.875rem;
    font-weight: 600;
    color: #4c5461;
    line-height: 1.75rem;
  }

  .styleBox_02 div ul li img {
    width: 1rem;
    height: 1rem;
    margin-right: 0.625rem;
  }

  .styleBox_02 img {
    width: 95%;
    margin: 0 auto;
    max-width: 1180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comForPc/English_model/E_way.vue